import { useState, useCallback } from "react";
import axios from "axios";
import { message } from "antd"; // optional if you're using Ant Design
import { apiV1Endpoint } from "../../../../api/v1/endpoints";
import { transformDynamicFields } from "../../DynamicFields";

/**
 * Custom hook for posting lease configuration data
 */
export const usePostLeaseConfiguration = (leaseId) => {
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState(null);

  /**
   * Post lease configuration API call
   */
  const postLeaseConfiguration = useCallback(async (payload) => {
    setLoading(true);
    setError(null);

    let leaseConfig = transformDynamicFields(payload);

    try {
      const response = await axios.patch(`${apiV1Endpoint}/booking/details/${leaseId}`, { leaseConfig });

      setResponseData(response.data);
      message.success("Lease configuration saved successfully"); // optional
      return response.data;
    } catch (err) {
      console.error("Error posting lease configuration:", err);
      setError(err.response?.data || err.message);
      message.error(err.response?.data?.message || "Failed to save lease configuration");
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    postLeaseConfiguration,
    loading,
    error,
    responseData,
  };
};
